'use client';

import Link from '@eliadmin/core/src/components/link';

import { SignInDialog } from '@eliadmin/core/src/components/dialog/lazy-dialogs';
import { prefetchSocialAuthProviders } from '@eliadmin/core/src/components/auth/social-auth-providers-cache';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { RiAccountCircleLine } from 'react-icons/ri';

export const HeaderProfileButton = ({ whiteText }: { whiteText: boolean }) => {
  const { t } = useTranslations();

  const me = useCustomerStore(s => s.me);
  const locale = useLocaleStore(s => s.currentLocale);
  const isInitialized = useCustomerStore(s => s.isInitialized);

  const isLoggedIn = me && !!isInitialized;

  const openDialog = useDialogStore(s => s.open);

  const warmSocialAuthProviders = () => {
    void prefetchSocialAuthProviders(locale);
  };

  const handleSignInClick = () => {
    warmSocialAuthProviders();
    openDialog({
      id: SignInDialog.id,
      content: <SignInDialog />,
    });
  };

  if (!isInitialized) {
    return (
      <Button size={'none'} variant={'none'} disabled aria-label={t('text190')}>
        <RiAccountCircleLine
          size={20}
          aria-hidden
          className={cn(whiteText ? 'text-white' : 'text-black')}
        />
      </Button>
    );
  }

  // Figma shows the account glyph in both states — signed out it opens the sign-in dialog,
  // signed in it links to the profile — rather than the word "Prihlásenie" when signed out.
  if (isInitialized && !me) {
    return (
      <Button onClick={handleSignInClick} variant={'none'} size={'none'} aria-label={t('text190')}>
        <RiAccountCircleLine size={20} className={cn(whiteText ? 'text-white' : 'text-black')} />
      </Button>
    );
  }

  if (isLoggedIn) {
    return (
      <Button asChild variant={'none'} size={'none'} aria-label={t('text197')}>
        <Link href={ROUTES.PROFILE()}>
          <RiAccountCircleLine size={20} className={cn(whiteText ? 'text-white' : 'text-black')} />
        </Link>
      </Button>
    );
  }
};
